export function isWorkspaceAdminRole(role: string | undefined | null): boolean {
  return role === "owner" || role === "admin";
}

export function isPostableRoomRole(role: string | undefined | null): boolean {
  return role === "owner" || role === "admin" || role === "member";
}

export function validateWebhookDisplayName(name: string): string | null {
  const trimmed = name.trim();
  if (!trimmed) return "表示名を入力してください。";
  if (trimmed.length > 80) return "表示名は 80 文字までです。";
  return null;
}
